module.exports = __webpack_public_path__ + "img/175.98a90979.jpg";